export const editMutations = <const>{
	VYROBEK_VOZ_DODAVATEL_SELECT_MAPPER: 'VYROBEK_VOZ_DODAVATEL_SELECT_MAPPER',
};
